/* eslint-disable no-undef */
import React from 'react';
import { render } from 'react-dom';
import CalendlyModal from 'shared/components/CalendlyModal';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('calendly-modal-container');

  if (container) {
    const { buttonId, url, prefillMessage } = container.dataset;
    const prefillField = 'a1';

    if (url) {
      render(
        <CalendlyModal
          buttonId={buttonId}
          url={url}
          prefillMessage={prefillMessage}
          prefillField={prefillField}
        />,
        container
      );
    }
  }
});
